import React from 'react';
import S from '../Footer/StyledFooter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt, faEnvelope} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'gatsby';

const CustomFooter = () => {
    return ( 
        <S.FooterWrapper>
            <S.Footer>
                
                <S.Section>
                    <S.Title>Szybkie linki</S.Title>
                    <S.SectionContent>
                        <span><Link to='/firma-nda'>O firmie NDA</Link></span>
                        <span><Link to='/#oferta'>Oferta</Link></span>
                        <span><Link to='/nadzor-budowlany-realizacje-zachodniopomorskie/'>Realizacje</Link></span>
                        <span><Link to='/kierownik-budowy-zachodniopomorskie/'>Kierownik budowy</Link></span>
                        <span><Link to='/inspektor-nadzoru-inwestorskiego/'>Inspektor nadzoru inwestorskiego</Link></span>
                        <span><Link to='/przeglad-okresowy-budynkow/'>Przegląd okresowy budynków</Link></span>
                    </S.SectionContent>
                </S.Section>

                <S.Section>
                    <S.Title>Dane firmy</S.Title>
                    <S.SectionContent>
                        <span>NDA</span>
                        <span>mgr inż. Dawid Mroczek</span>
                        <span>ul. Tylna 6B/8, 73-210 Recz</span>
                    </S.SectionContent>
                </S.Section>

                <S.Section>
                    <S.Title>Kontakt</S.Title>
                    <S.SectionContent>
                        <a href="tel:+48723902000" className="phone-number"><FontAwesomeIcon icon={faPhoneAlt}/>723 90 2000</a>
                        <a href="mailto:dawid.mroczek@nda-nazdor.pl"><FontAwesomeIcon icon={faEnvelope}/>dawid.mroczek@nda-nazdor.pl</a>
                    </S.SectionContent>
                </S.Section>

            </S.Footer>
            <S.Copyright>
                NDA &copy; {1900 + new Date().getYear()}
            </S.Copyright>
        </S.FooterWrapper>
     );
}
 
export default CustomFooter;